import styled from 'styled-components';

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 30px;
  margin-left: 100px;
  margin-top: 30px;
`;

export const InputSearchContainer = styled.div`
  width: 350px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  background-color: #F3F3F3;
  font-size: 12px;
  font-weight: bold;
  border: none;
  margin-top: 30px;
  margin-right: 100px;
`;
